import { fetchJson } from "../lib/api";
import type { CreditCostCenterReview, CreditCostCenterTarget } from "./creditCostCenterReview";
import type { Source } from "./hilti";

export type HiltiTarget = CreditCostCenterTarget;
export type HiltiReview = {
  line: CreditCostCenterReview["line"] & { line_net_amount: string | null };
  source_sha256: string;
  source_binding: string;
  references: { label: string; raw: string; source: Source }[];
  revision: number;
  can_review: boolean;
  decision_active: boolean;
  decision_issue: string | null;
  decision: { status: "assigned" | "deferred" | "open"; target: HiltiTarget | null; revision: number } | null;
  history: { event_id: string; operation: "assign" | "defer" | "undo";
    after: { target: HiltiTarget | null }; reason: string; created_at: string; actor_label: string;
    source_sha256: string; references: {label: string; raw: string; source: Source}[] }[];
};
const base = "/api/hilti-cost-center-review";
const positionUrl = (docId: string, linePos: string) => `${base}/${encodeURIComponent(docId)}/${encodeURIComponent(linePos)}`;
export const fetchHiltiReview = (docId: string, linePos: string) => fetchJson<HiltiReview>(positionUrl(docId,linePos));
export const fetchHiltiTargets = (query: string) => fetchJson<{items: HiltiTarget[]}>(`${base}/targets?q=${encodeURIComponent(query)}`);
export type HiltiDecision = { request_id: string; action: "assign" | "defer" | "undo"; target_key: string | null;
  reason: string; original_checked: boolean; expected_revision: number; expected_binding: string };
export const saveHiltiReview = (docId: string, linePos: string, body: HiltiDecision) =>
  fetchJson<HiltiReview>(positionUrl(docId,linePos), {method:"POST",body:JSON.stringify(body)});
